import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { Fade } from 'react-reveal';
import { Actions } from '../../../flux';
import { images, texts } from '../../../settings';
import { DelayLink } from '../../../components';

import './Card10.scss';

class Card10 extends Component {
  constructor(props) {
    super(props);

    this.contentText = React.createRef();
  }

  scrollTop = () => {
    window.scrollTo({ top: this.contentText.current.offsetTop });
  };

  componentDidMount = () => {
    Actions.headerIntern();
    this.scrollTop();
  };

  render = () => {
    return (
      <div className="views" ref={this.contentText}>
        <Helmet>
          <title>Pandemia acelera agenda de mercado de capitais - Iniciativas - {texts.title}</title>
        </Helmet>

        <div className="iniciativas-home card10-home page-gradient page-gradient--yellow bg-gray" ref="card10-home">
          <section className="iniciativas-area card10-area page--yellow">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <Fade bottom>
                    <div className="card card--page-body card--yellow">
                      <div className="card__content">
                        <div className="card__content__header">
                          <DelayLink
                            to="/estrategias/para-o-mercado"
                            className="button button--aylen button--gray-500 button--border-medium button--size-m button--round-l button--text-thick"
                          >
                            Voltar
                          </DelayLink>
                          <h1 className="title">Pandemia acelera agenda de mercado de capitais</h1>
                        </div>
                        <div className="card__content__body">
                          <div className="row flex">
                            <div className="col-12">
                              <p>
                                A pandemia e um de seus efeitos mais visíveis, a migração para o trabalho remoto,
                                aceleraram a adoção de algumas pautas que já eram prioritárias na agenda de mercado de
                                capitais e que se tornaram ainda mais relevantes nesse contexto.
                              </p>
                              <p>
                                Exemplos disso foram as flexibilizações regulatórias, entre elas as relacionadas a
                                assembleias e votos virtuais. Pleito antigo do mercado, a realização de assembleias
                                digitais e a permissão do voto a distância para debenturistas foram regulamentadas em
                                maio, com a publicação da{' '}
                                <a href="http://conteudo.cvm.gov.br/legislacao/instrucoes/inst625.html" target="_blank">
                                  Instrução CVM 625
                                </a>
                                . As normas também devem ser aplicadas a titulares de notas promissórias, CRIs
                                (Certificados de Recebíveis Imobiliários) e CRAs (Certificados de Recebíveis do
                                Agronegócio).
                              </p>
                              <p>
                                O ano também foi marcado pelas ações com foco no fomento ao mercado secundário de
                                títulos corporativos. Uma das principais iniciativas foi a ampla disseminação do{' '}
                                <a
                                  href="https://www.anbima.com.br/data/files/D2/D4/4C/72/BE46D6100FB0C4D6192BA2A8/Guia_Padronizacao_Debentures.pdf"
                                  target="_blank"
                                >
                                  Guia de Padronização de Debêntures
                                </a>
                                , que apresenta as melhores práticas para a elaboração das escrituras desses ativos.
                                Apresentamos o material, lançado em 2019, a outras entidades do mercado e trabalhamos na
                                sensibilização de emissores e demais agentes envolvidos nesse tipo de operação. A
                                padronização do cálculo da remuneração das debêntures tem o potencial de melhorar o
                                processo de precificação dos ativos, ampliar a transparência e, assim, aumentar a
                                liquidez dos papéis.
                              </p>
                            </div>
                          </div>

                          <div className="col-12">
                            <p>
                              Em 2020, avançamos ainda na securitização de recebíveis, com propostas para a sua
                              modernização. Como relatores do tema na IMK (Iniciativa Mercado de Capitais), sugerimos a
                              construção de um marco legal único para as diversas estruturas, considerando, sobretudo,
                              sua importância para o crescimento do crédito em setores como o imobiliário, de
                              agronegócio e o financeiro. Nesse sentido, participamos ativamente da audiência pública da
                              CVM que estabeleceu regras próprias às companhias securitizadoras de direitos creditórios.
                            </p>
                            <p>
                              Incluímos também novas regras e procedimentos de classificação de CRIs e CRAs no nosso
                              Código de Ofertas Públicas. A proposta passou por audiência pública no fim de 2020 e tem
                              por objetivo ampliar a transparência desses ativos aos investidores. A minuta indicou
                              ainda normas voltadas aos agentes fiduciários, que deverão prestar informações sobre
                              garantias e ofertas de CRIs e CRAs para o cumprimento de suas atividades.
                            </p>
                            <p>
                              Em conjunto com a CVM, analisamos o entendimento dos investidores de varejo sobre a
                              documentação dos ativos no processo das ofertas públicas. O estudo evidenciou a falta de
                              clareza sobre o funcionamento das ofertas e a dificuldade de comparação entre alguns
                              papéis, como debêntures, CRIs e CRAs. As descobertas devem ser consideradas na
                              reestruturação das regras de ofertas (ICVM 400 e 476), principalmente sobre a documentação
                              das emissões. Com as futuras mudanças na regulação, revisaremos o nosso Código de Ofertas
                              Públicas para adequá-lo às novas exigências.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Fade>
                </div>
              </div>
            </div>
            <div className="container">
              <div className="row">
                <div className="col-12 box">
                  <h3>Mercado de capitais: caminho para o desenvolvimento</h3>
                  <div className="col-7">
                    <p>
                      Em 2020, foi lançada a edição revisada da{' '}
                      <a
                        href="https://d335luupugsy2.cloudfront.net/cms/files/43228/1605739416Agenda-ANBIMA-B3-2020.pdf"
                        target="_blank"
                      >
                        Agenda ANBIMA e B3 para Desenvolvimento do Mercado de Capitais
                      </a>
                      . Dois anos depois da{' '}
                      <a
                        href="https://www.anbima.com.br/pt_br/especial/mercado-de-capitais-caminho-para-o-desenvolvimento.htm"
                        target="_blank"
                      >
                        primeira versão
                      </a>
                      , atualizamos o documento junto com a B3 em um novo esforço para consolidar propostas capazes de
                      estimular o crescimento dos mercados de renda fixa e variável. Nesta agenda, listamos as
                      iniciativas de caráter microeconômico e as sugestões de ajustes regulatórios que podem contribuir
                      para a expansão dos instrumentos privados de financiamento de longo prazo. Os principais objetivos
                      são:
                    </p>
                  </div>
                  <div className="col-5 img-center h-img">
                    <img src={images.iniciativas.card10.img1} />
                  </div>
                  <div className="row">
                    <div className="col-3">
                      <ul>
                        <li>
                          <p>
                            Diversificação
                            <br />
                            da base
                            <br />
                            de investidores
                          </p>
                        </li>
                      </ul>
                    </div>
                    <div className="col-3">
                      <ul>
                        <li>
                          <p>
                            Estímulo
                            <br />
                            ao mercado
                            <br />
                            secundário
                          </p>
                        </li>
                      </ul>
                    </div>
                    <div className="col-3">
                      <ul>
                        <li>
                          <p>
                            Ampliação
                            <br />
                            da base
                            <br />
                            de emissores
                          </p>
                        </li>
                      </ul>
                    </div>
                    <div className="col-3">
                      <ul>
                        <li>
                          <p>
                            Fomento
                            <br />à securitização
                          </p>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  };
}

export { Card10 };
